import { render, staticRenderFns } from "./ColumnMappingLabPreset.vue?vue&type=template&id=5d793480&scoped=true&lang=html&"
import script from "./ColumnMappingLabPreset.vue?vue&type=script&lang=js&"
export * from "./ColumnMappingLabPreset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d793480",
  null
  
)

export default component.exports